import { render, staticRenderFns } from "./PaymentTransportersCollectHistory.vue?vue&type=template&id=53e49ade"
import script from "./PaymentTransportersCollectHistory.vue?vue&type=script&lang=js"
export * from "./PaymentTransportersCollectHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports